import { render, staticRenderFns } from "./NewsActionButton.vue?vue&type=template&id=4f07febc&scoped=true"
import script from "./NewsActionButton.vue?vue&type=script&lang=js"
export * from "./NewsActionButton.vue?vue&type=script&lang=js"
import style0 from "./NewsActionButton.vue?vue&type=style&index=0&id=4f07febc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f07febc",
  null
  
)

export default component.exports